import styled from '@emotion/styled';
import { Card as AntdCard } from 'antd';
import type { CardProps as AntdCardProps } from 'antd';
import tw from 'twin.macro';

const Card = ({ children, ...rest }: AntdCardProps) => {
  return <StyledCard {...rest}>{children}</StyledCard>;
};

export default Card;

const StyledCard = styled(AntdCard)`
  ${tw`border-none my-[5px] w-full`}

  .ant-card-head {
    ${tw`min-h-[unset] py-[10px] px-0 border-none`}

    &-title {
      ${tw`text-[16px] font-semibold`}
    }
  }

  .ant-card-body {
    ${tw`flex flex-col items-start w-full border-[1px] border-solid border-[#f0f0f0] rounded-[8px]`}
  }
`;
